import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// This is a custom hook that encapsulates the useSelector hook and allows you to pass in arguments to the selector function.
// One possible use is alongside the createSelector function from the reselect library.
// Creating a hook with this allows you to use that hook anywhere in react components without having to pass state.
// https://reselect.js.org/faq/#how-can-i-make-a-curried-selector
export const createParametricSelectorHook = <Result, Params extends readonly unknown[]>(
    selector: (state: RootState, ...params: Params) => Result,
) => {
    return (...args: Params) => {
        return useAppSelector((state: RootState) => selector(state, ...args));
    };
};
